import React from 'react'

const InfoSection = () => (
  <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
    <p className='txt-subtitle txt-font-body color-ui-2'>
      • Pagamentos de segunda à sexta-feira, das 9h às 18h;
    </p>
    <p className='txt-subtitle txt-font-body color-ui-2'>
      • Permitido apenas 1 (um) pagamento a cada 24 horas;
    </p>
    <p className='txt-subtitle txt-font-body color-ui-2'>
      • Pagamentos devem ser realizados até 2 (dois) dias antes do vencimento;
    </p>
    <p className='txt-subtitle txt-font-body color-ui-2'>
      • Valor limite do boleto: R$ 400,00 para contas de água, luz, telefone e
      gás;
    </p>
  </div>
)

export default InfoSection



// WEBPACK FOOTER //
// ./src/features/BillPayment/Sidebar/InfoSection.js